var _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgListGrayIc = function SvgListGrayIc(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6CC",
    fillRule: "nonzero",
    d: "M5.5 17a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2h1.5zM20 17a1 1 0 0 1 0 2H8.645a1 1 0 0 1 0-2H20zM5.5 11a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2h1.5zM20 11a1 1 0 0 1 0 2H8.645a1 1 0 0 1 0-2H20zm0-6a1 1 0 0 1 0 2H8.645a1 1 0 1 1 0-2H20zM5.5 5a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2h1.5z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListGrayIc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list_gray_ic.5370472f.svg";
export { ForwardRef as ReactComponent };